export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.8-1304.25",
  commitId: "05d53631752ce8cc2f3e3991a50e40c9986ac305",
  commitTime: "2026-09-08T13:04:25.000Z",
});
